<template>
    <div>
        <EncabezadoCard
                :titulo="'Iniciar Sesión'"
                :sub-titulo="'Ingrese su password'"
                :icono="'mdi-lock'"
                style="background-color: #FAFAFA"
        ></EncabezadoCard>

        <v-form @submit.prevent="autenticar" ref="form" v-model="valid"
                lazy-validation>
            <v-card-text>
                <v-container>

                    <v-row>
                        <v-col cols="12" xs="12" class="text-center">
                            <div class="headline mb-1">{{miusuario.nombre}}</div>

                            <v-list-item-title class="title mb-1 ">{{miusuario.cuenta}}</v-list-item-title>
                        </v-col>
                        <v-col cols="12" xs="12">

                            <v-text-field
                                    v-model="password"
                                    id="password"
                                    label="Password (*)"
                                    :append-icon="mostrarPass ? 'mdi-eye-off' : 'mdi-eye'"
                                    @click:append="() => (mostrarPass = !mostrarPass)"
                                    :type="mostrarPass ? 'password' : 'text'"
                                    required
                                    :counter="20"
                                    maxlength="20"
                                    autocomplete="off"
                                    :rules="[v => !!v || 'Password es requerido',
                                                           v => (v && v.length <= 20 && v.length>=6) || 'El Password debe ser de 6 a 50 caracteres']"/>
                        </v-col>
                    </v-row>

                </v-container>

            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn type="button" class="default" @click="vaciar">
                    <v-icon left>mdi-arrow-left-bold</v-icon>
                    Volver
                </v-btn>
                <v-btn type="submit" color="primary" class="pl-4 pr-4" :disabled="loading"> Ingresar
                    <v-progress-circular
                            v-if="loading"
                            indeterminate
                            color="primary"
                            style="margin-left: 10px"
                    ></v-progress-circular>
                    <v-icon left>mdi-arrow-right-bold</v-icon>

                </v-btn>

            </v-card-actions>
        </v-form>

    </div>
</template>

<script>
    import EncabezadoCard from "../../components/EncabezadoCard";
    import {mapState} from "vuex";

    export default {
        name: "loginPassowrd",
        components: {EncabezadoCard},
        props: ['miusuario'],
        data: () => ({
            mostrarPass: String,
            loading: false,
            valid: false,
            password: '',
        }),
        mounted() {
            document.getElementById("password").focus();
        },
        methods: {
            vaciar() {
                this.password = '';
                this.$emit('setMiUsuario', '');
            },

            autenticar() {
                if (!this.$refs.form.validate()) {
                    return;
                }
                this.loading = true;

                this.$store.dispatch("getToken", {
                    "email": this.miusuario.cuenta,
                    "password": this.password
                }).then(response => {
                    if (response.data.res) {
                        this.loading = false;
                        if (response.data.cambiarPassword) {
                            this.$emit('setToken', response.data);
                            this.$emit('setMiPassword', this.password);
                            this.$emit('changePassword');
                        } else {
                            this.$router.push({name: "Home"});
                        }
                    } else {
                        this.loading = false;
                        this.$toastr.error(response.data.message);
                    }
                }).catch(e => {
                    this.loading = false;
                    this.$toastr.error(this.$funciones.listaErrores(e.response.data.errors));
                });
            }
        },
        computed: {
            ...
                mapState(['url_base', 'token'])
        }
    }
</script>

<style scoped>

</style>